// DateFormatPicker — per-file-column date-format chooser, shared by the import
// wizard (create/edit) and the saved-import runner. Lists detected date columns
// (with a "show all" escape) and previews how each sample value parses.
//
// Props:
//   columns: [{ header, sample, candidate }]   // candidate = likely a date column
//   value:   { [header]: formatKey }           // current selections
//   onChange(header, key)                       // set/clear a column's format
import { createSignal, Show, For } from 'solid-js';
import { DATE_FORMATS, previewDate } from '../lib/dateformats.js';

export default function DateFormatPicker(props) {
  const [showAll, setShowAll] = createSignal(false);
  const candidates = () => props.columns.filter((c) => c.candidate);
  const visible = () => (showAll() ? props.columns : candidates());
  const hiddenCount = () => props.columns.length - candidates().length;

  return (
    <div class="import-dateformats">
      <div class="import-section-title">
        Date formats <span class="muted">— how date columns are written in your file (others import as-is)</span>
      </div>

      <Show
        when={visible().length > 0}
        fallback={
          <div class="muted" style="font-size:12px;">
            No date-looking columns detected.{' '}
            <button class="btn btn-sm btn-ghost" onClick={() => setShowAll(true)}>Show all columns</button>
          </div>
        }
      >
        <div class="import-preview-wrap">
          <table class="import-preview">
            <thead><tr><th>Column</th><th>Format in file</th><th>Preview</th></tr></thead>
            <tbody>
              <For each={visible()}>
                {(c) => (
                  <tr>
                    <td class="mono">{c.header}</td>
                    <td>
                      <select class="input" style="min-width:160px;"
                              onChange={(e) => props.onChange(c.header, e.currentTarget.value)}>
                        <For each={DATE_FORMATS}>
                          {(f) => <option value={f.key} selected={(props.value[c.header] || '') === f.key}>{f.label}</option>}
                        </For>
                      </select>
                    </td>
                    <td class="mono muted">
                      <Show when={props.value[c.header]} fallback={<span>{c.sample ?? ''}</span>}>
                        <Show when={previewDate(c.sample, props.value[c.header])}
                              fallback={<span style="color:var(--danger)">can’t parse “{c.sample}”</span>}>
                          {previewDate(c.sample, props.value[c.header])}
                        </Show>
                      </Show>
                    </td>
                  </tr>
                )}
              </For>
            </tbody>
          </table>
        </div>
        <Show when={!showAll() && hiddenCount() > 0}>
          <button class="btn btn-sm btn-ghost" style="margin-top:6px;" onClick={() => setShowAll(true)}>
            Show all columns ({hiddenCount()} more)
          </button>
        </Show>
      </Show>
    </div>
  );
}
